export default "__VITE_ASSET__CMUmh$Xa__"